import ApiService from '../api/ApiService';

const errors = {
  401: 'api_error_unauthorized',
  404: 'api_error_route_not_found',
  400: 'api_error_failed_update_record_inspection',
  405: 'api_error_failed_update_record_inspection',
  500: 'api_error_internal_error',
  default: 'api_error_failed_update_record_inspection',
};
export default async function updateReportInspection(data) {
  try {
    const rawResponse = await ApiService(
      'updateReportInspection',
      { recordId: data.recordId },
      null,
      JSON.stringify(data),
    );

    if (Object.prototype.hasOwnProperty.call(errors, rawResponse.status)) throw new Error(errors[rawResponse.status]);
    if (rawResponse.status > 299) throw new Error(errors.default);
    return rawResponse.data;
  } catch (e) {
    throw new Error(errors.default);
  }
}
